import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export function ProfilePage() {
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!user) {
        return <div className="p-5 text-center">Loading profile...</div>;
    }

    return (
        <Container fluid className="p-4">
            <h1 className="h3 mb-4">My Profile</h1>

            <Row>
                <Col md={8} lg={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="text-center py-5">
                            <div className="mb-4 position-relative d-inline-block">
                                {user.avatar ? (
                                    <Image
                                        src={user.avatar}
                                        roundedCircle
                                        style={{ width: 120, height: 120, objectFit: 'cover' }}
                                        className="border border-3 border-white shadow"
                                    />
                                ) : (
                                    <div
                                        className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white mx-auto shadow"
                                        style={{ width: 120, height: 120, fontSize: '3rem' }}
                                    >
                                        {user.name?.charAt(0).toUpperCase() || <i className="bi bi-person"></i>}
                                    </div>
                                )}
                            </div>

                            <h2 className="h4 mb-1">{user.name}</h2>
                            <p className="text-muted mb-4">{user.email}</p>

                            <div className="d-flex justify-content-center gap-2">
                                <Button variant="outline-primary" onClick={() => navigate('/profile/edit')}>
                                    <i className="bi bi-pencil me-2"></i> Edit Profile
                                </Button>
                                <Button variant="outline-secondary" onClick={() => navigate('/settings')}>
                                    <i className="bi bi-gear me-2"></i> Settings
                                </Button>
                            </div>
                        </Card.Body>
                        <Card.Footer className="bg-body-secondary p-3">
                            <Row className="text-center">
                                <Col>
                                    <div className="fw-bold text-body">Member Since</div>
                                    <small className="text-muted">
                                        {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}
                                    </small>
                                </Col>
                                <Col className="border-start">
                                    <div className="fw-bold text-body">User ID</div>
                                    <small className="text-muted font-monospace user-select-all" style={{ fontSize: '0.75rem' }}>
                                        {user.id.substring(0, 8)}...
                                    </small>
                                </Col>
                            </Row>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
